module.exports = __webpack_public_path__ + "static/climate_spanish-9220b1e578ab918e6487a17b2798aeab.png";